<template>
    <div>Authenticating...</div>
</template>
<script>

export default {
    name: "integration",
};
</script>